import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { get } from "../../_api";
import ListElem from "../List/ListElem";
import { Button, Stack, Text } from "@mantine/core";

interface IPageRes {
  _id: string;
  title: string;
  slug: string;
  active: boolean;
  meta: { createdDate: string };
}

const Pages: React.FC = () => {
  const [pages, setPages] = useState<IPageRes[]>([]);

  useEffect(() => {
    get("dynamic-pages").then((res: IPageRes[]) => setPages(res));
  }, []);

  return (
    <Stack gap="md" maw={1200} mx="auto" px="md" pb={250}>
      <Button component={Link} to="/pages/new" size="md" radius="md" w={{ base: "100%", sm: "auto" }}>
        Dodaj stronę
      </Button>

      <Stack gap={0}>
        {pages.length === 0 && <Text>Brak stron</Text>}
        {pages.map((page, i) => (
          <ListElem
            id={page._id}
            key={page._id}
            order={i + 1}
            infoBig={page.title}
            infoSmall={page.active ? undefined : "Nieaktywna"}
            date={page.meta?.createdDate || new Date()}
            link={`/pages/${page._id}`}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default Pages;
